/**
 * ClientServiceRegistryService 实现
 *
 * 业务服务注册服务的核心实现，负责业务服务实例的注册、存储、查找和卸载。
 */
/**
 * 业务服务注册服务
 *
 * ui-registry-mod 的核心服务之一，业务 Mod 通过此服务注册可跨模块共享的业务服务。
 */
export class ClientServiceRegistryService {
    constructor(deps) {
        this.services = {};
        this.modRegistry = new Map();
        this.eventBus = deps?.eventBusService;
    }
    registerService(modName, serviceTag, instance) {
        // 校验服务冲突
        if (this.services[serviceTag]) {
            throw new Error(`Service conflict: ${serviceTag} already registered`);
        }
        // 注册服务
        this.services[serviceTag] = instance;
        // 记录模块注册的服务名
        if (!this.modRegistry.has(modName)) {
            this.modRegistry.set(modName, new Set());
        }
        this.modRegistry.get(modName).add(serviceTag);
        if (this.eventBus) {
            this.eventBus.emit('service:registered', {
                modName,
                serviceTag,
            });
        }
    }
    unregisterModServices(modName) {
        const keys = this.modRegistry.get(modName);
        if (keys) {
            for (const key of keys) {
                delete this.services[key];
            }
            this.modRegistry.delete(modName);
        }
        if (this.eventBus) {
            this.eventBus.emit('service:unregistered', { modName });
        }
    }
    getServices() {
        return { ...this.services };
    }
    getServicesByMod(modName) {
        const keys = this.modRegistry.get(modName);
        if (!keys)
            return {};
        const result = {};
        for (const key of keys) {
            if (this.services[key]) {
                result[key] = this.services[key];
            }
        }
        return result;
    }
}
//# sourceMappingURL=client-service-registry.js.map